/**
 * Common slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  loader: false,
  error: null as string | null,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    presentLoader(state) {
      state.loader = true;
      state.error = null;
    },
    dismissLoader(state) {
      state.loader = false;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loader = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutApp, () => {
      return initialState;
    });
  },
});

// Reducer
export const commonReducer = commonSlice.reducer;

// Actions
export const {
  presentLoader,
  dismissLoader,
  setError,
  clearError,
} = commonSlice.actions;

// Other Actions
export const logoutApp = createAction('COMMON/LOGOUT');

